import Vue from 'vue';
import VueRouter from 'vue-router';
import VueGtm from 'vue-gtm';
import Registration from '../views/Registration.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'registration',
    component: Registration,
  },
  {
    path: '/testing',
    name: 'testing',
    component: () => import('../views/Testing.vue'),
  },
  {
    path: '/beginning',
    name: 'beginning',
    component: () => import('../views/Beginning.vue'),
  },
  {
    path: '/finish',
    name: 'finish',
    component: () => import('../views/Finish.vue'),
  },
  {
    path: '/result/:id',
    name: 'result',
    component: () => import('../views/Result.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

Vue.use(VueGtm, {
  id: 'GTM-NSZ8G6C',
  debug: process.env.NODE_ENV !== 'production',
  vueRouter: router,
});

export default router;
